<template>
<div>
    <div class="relative sombra" v-if="asignacion" >
        <AsignacionAspirante style="position: fixed;top: 50%; left: 50%; transform: translate(-50%, -50%);width: 50%;z-index:1000" 
        :aspirante="aspiranteId"
        :designacion="designacion"
        v-on:guardada="closeAsignacionDialog"
        v-on:cancelada="closeAsignacionDialog"
        ></AsignacionAspirante>
    </div>

    <!--div class="lds-roller" v-if="form.processing"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div-->
    <div class="ld-container" v-if="form.processing"> <!--There's the container that centers it-->
        <div class="spinner-frame"> <!--The background-->
            <div class="spinner-cover"></div> <!--The Foreground-->
            <div class="spinner-bar"></div> <!--and The Spinny thing-->
        </div>
    </div>
    
    <div class="relative sombra" v-if="dialogFormularioCfj">
        <FormularioCfj style="position: fixed;top: 50%; left: 50%; transform: translate(-50%, -50%);width: 50%;z-index:1000"
        :aspirante="this.$page.props.aspirante.id"
        :cursos="curso"
        v-on:guardarCurso="closeCfjDialog"
        v-on:cancelarCurso="closeCfjDialog"
        ></FormularioCfj>
    </div>
    <h1 class="font-bold text-3xl mb-16">
        <inertia-link v-if="$page.props.auth.user.owner" class="text-enlace text-purple-300 hover:text-indigo-600" :href="route('aspirantes.list')">Aspirantes</inertia-link>
        <span v-if="$page.props.auth.user.owner" class="text-enlace font-medium">/</span>
        <span>{{ nombre }} {{ apellido }}</span>
        <span v-if="numero_inscripcion" style="display: block;float: right" class="text-black">Número Inscripción: {{numero_inscripcion}}</br>Fecha Inscripción: {{fecha_inscripcion}}</span>
    </h1>
    <!-- <img v-if="user.photo" class="block w-8 h-8 rounded-full ml-4" :src="user.photo" /> -->

    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update" enctype="multipart/form-data" >
        <header @click="showDatos=!showDatos" class="flex items-center rounded-md header-form">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Datos Personales
            </span>

        </header>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap " v-show="showDatos">

            <text-input v-model="form.cuit_cuil" class="pr-6 pb-8 w-full lg:w-1/1 " label="Cuil" readonly/>

            <text-input required v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2 " label="Nombre" />
            <text-input required v-model="form.apellido" :error="form.errors.apellido" class="pr-6 pb-8 w-full lg:w-1/2" label="Apellido" />
            <select-input required v-model="form.tipo_documento_id" :error="form.errors.tipo_documento_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Tipo Documento">
                <option :value="null" />
                <option value="1">DNI</option>
                <option value="2">LC</option>
            </select-input>
            <text-input required v-model="form.numero_documento" :error="form.errors.numero_documento" class="pr-6 pb-8 w-full lg:w-1/2" label="Número Documento" />
            <text-input required v-model="form.correo_electronico" :error="form.errors.correo_electronico" class="pr-6 pb-8 w-full lg:w-1/2" label="Email"  :readonly="true">{{email}}</text-input>
            <!-- <text-input v-model="form.fecha_de_nacimiento" :error="form.errors.fecha_de_nacimiento" class="pr-6 pb-8 w-full lg:w-1/2" label="Fecha Nacimiento" /> -->
            <div>
                <label class="form-label" >Fecha Nacimiento:</label>
                <el-date-picker value-format="yyyy-MM-dd" format="dd-MM-yyyy" type="date" v-model="form.fecha_de_nacimiento" :error="form.errors.fecha_de_nacimiento" placeholder="Seleccionar el día"></el-date-picker>
            </div>

            <file-input v-model="form.curriculum_adjunto" :error="form.errors.curriculum_adjunto" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept=".docx,.pdf" label="Cargar Currículum" />
            <label v-if="curriculum_adjunto"  class="pr-6 pb-8 w-full lg:w-1/2">
            Descargar Currículum:
            <a :href="curriculum_adjunto.original_url" :download="curriculum_adjunto.file_name" class="flex items-center group py-3">
                <icon name="printer" class="w-5 h-5 mr-3" />
                <button type="button" class="text-indigo-300">{{ curriculum_adjunto.file_name }}</button>
            </a>
            </label>
            <select-input v-model="form.certificado_de_discapacidad" :error="form.errors.certificado_de_discapacidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Certificado Discapacidad">
                <option :value="null" />
                <option value="SI">SI</option>
                <option value="NO">NO</option>
            </select-input>
            <file-input v-model="form.certificado_adjunto" :hidden="form.certificado_de_discapacidad !='SI'" :error="form.errors.certificado_adjunto" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept=".docx,.pdf" label="Cargar Certificado Único de Discapacidad" />
            <label v-if="certificado_adjunto" :hidden="form.certificado_de_discapacidad !='SI'"  class="pr-6 pb-8 w-full lg:w-1/2">
            Certificado Único de Discapacidad:
            <a :href="certificado_adjunto.original_url" :hidden="form.certificado_de_discapacidad !='SI'" :download="certificado_adjunto.file_name" class="flex items-center group py-3">
                <icon name="printer" class="w-5 h-5 mr-3" />
                <button type="button" class="text-indigo-300">{{ certificado_adjunto.file_name }}</button>
            </a>
            </label>
            <text-input v-model="form.adaptaciones_o_necesidades_requeridas" :error="form.errors.adaptaciones_o_necesidades_requeridas" class="pr-6 pb-8 w-full lg:w-1/2" label="Adaptaciones o ajustes requeridos" />
        </div>
        <div class="mx-auto mt-6  border-b-2" />

        <header @click="showDomicilio=!showDomicilio" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Domicilio
            </span>

        </header>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-show="showDomicilio">
            <text-input required v-model="form.domicilioConstituido_calle" :error="form.errors.domicilioConstituido_calle" class="pr-6 pb-8 w-full lg:w-1/2" label="Calle" />
            <text-input required v-model="form.domicilioConstituido_numero" :error="form.errors.domicilioConstituido_numero" class="pr-6 pb-8 w-full lg:w-1/2" label="Número" />
            <text-input v-model="form.domicilioConstituido_piso" :error="form.errors.domicilioConstituido_piso" class="pr-6 pb-8 w-full lg:w-1/2" label="Piso" />
            <text-input v-model="form.domicilioConstituido_departamento" :error="form.errors.domicilioConstituido_departamento" class="pr-6 pb-8 w-full lg:w-1/2" label="Dpto" />
            <text-input v-model="form.domicilioConstituido_codigo_postal" :error="form.errors.domicilioConstituido_codigo_postal" class="pr-6 pb-8 w-full lg:w-1/2" label="Código Postal" />
            <text-input v-model="form.domicilioConstituido_localidad" :error="form.errors.domicilioConstituido_localidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Localidad" />
            <text-input required class="pr-6 pb-6  w-1/3"  label="Código de Área" v-model="form.codigo_area_telefono" :error="form.errors.codigo_area_telefono"></text-input>
            <text-input required class="pr-6 pb-6" v-model="form.domicilioConstituido_telefono" :error="form.errors.domicilioConstituido_telefono"  label="Teléfono" ></text-input>
            <p class="m-6 text-gray-400 w-full">Código de área + N°. Ejemplo:011 2345-6789</p>
        </div>
        <div class="mx-auto mt-6  border-b-2" />

        <header @click="showExperiencia=!showExperiencia" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Experiencia Judicial
            </span>

        </header>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-show="showExperiencia">
            <select-input v-model="form.experiencia_judicial" :error="form.errors.experiencia_judicial" class="pr-6 pb-8 w-full lg:w-1/2" label="¿Trabajaste en el Poder Judicial?">
                <option value="NO" selected>NO</option>
                <option value="SI">SI</option>
            </select-input>
            <div class="w-full flex flex-wrap">
                <span class="font-bold pr-6 pb-8 mb-2 w-full">Aplica para qué cargo:</span>
                <select-input v-model="form.auxiliar" :error="form.errors.auxiliar" class="pr-6 pb-8 w-full lg:w-1/2" label="Auxiliar">
                    <option value="NO" selected>NO</option>
                    <option value="SI">SI</option>
                </select-input>
                <select-input v-model="form.auxiliar_de_servicio" :error="form.errors.auxiliar_de_servicio" class="pr-6 pb-8 w-full lg:w-1/2" label="Auxiliar de Servicios">
                    <option value="NO">NO</option>
                    <option value="SI">SI</option>
                </select-input>
            </div>
            <div class="w-full">
                <span class="font-bold">Cuéntenos cual es su experiencia en el ámbito judicial:</span>
                <VueEditor  v-model="form.detalle_exp_judicial" class="pr-6 pb-8 mt-1 w-full font-bold"/>
            </div>
        </div>
        <div class="mx-auto mt-6  border-b-2" />

        <header @click="showEstudios=!showEstudios" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Estudios
            </span>

        </header>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-show="showEstudios">

            <select-input v-model="form.estudio_id" :error="form.errors.estudio_id" class="my-4 pr-6 pb-8 w-full lg:w-1/2" label="Tipo de Estudio">
            <option :value="null" />
            <option v-for="estudio in lista_estudios.data" :key="estudio.id" :value="estudio.id">{{ estudio.estudio }}</option>
          </select-input>
            <div class="w-full">
                <span class="font-bold">Carrera:</span>
                <VueEditor  v-model="form.universitario_descripcion" class="pr-6 pb-8 mt-1 w-full font-bold"/>
                <span class="font-bold">Qué otro estudio posee:</span>
                <VueEditor  v-model="form.tipoestudio" class="pr-6 pb-8 mt-1 w-full"/>
            </div>
        </div>
        <div class="mx-auto mt-6  border-b-2" />

        <header @click="showIntereses=!showIntereses" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Intereses
            </span>

        </header>

        <div class="p-8 -mr-6 flex flex-wrap" v-show="showIntereses">
            <span class="font-bold">Intereses:</span>
            <VueEditor  v-model="form.intereses" class="pr-6 pb-8 mt-1 w-full"/>
        </div>
        <div class="mx-auto mt-6  border-b-2" v-if="this.$page.props.auth.user.is_admin"/>

        <header @click="showDesignaciones=!showDesignaciones" v-if="this.$page.props.auth.user.is_admin" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Seguimientos
            </span>

        </header>

        <div class="p-8 -mr-6 flex flex-wrap" v-show="showDesignaciones" v-if="this.$page.props.auth.user.is_admin">
            <table class="w-full" style="margin: 0 10% 0 2% !important;" ref="tableDesginado">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4">Designado</th>
                    <th class="px-6 pt-6 pb-4">Resolucion</th>
                    <th class="px-6 pt-6 pb-4">Observación</th>
                    <th class="px-6 pt-6 pb-4">Fecha creación</th>
                    <th class="px-6 pt-6 pb-4 text-center">Acciones</th>

                </tr>
                <tr v-for="designacion in this.$page.props.aspirante.designaciones" :key="designacion.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                            <!-- {{ designacion.designado }} -->
                            {{designacion.designado | sino}}
                    </td>
                     <td class="border-t px-6 pt-6 pb-4 text-left">
                            {{ designacion.resolucion }}
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                            {{  designacion.observacion }}
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                            {{ designacion.fecha_asignacion }}
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-center">
                        <button type="button" class="mt-8 btn-login relative" v-on:click="asigna(aspirante.id,designacion)">Editar</button>
                    </td>
                    
                </tr>
                <button type="button" class="mt-8 btn-login relative" @click="asigna(aspirante.id, designacion)" >Agregar Seguimiento</button>
            </table>
        </div>
        
      <div class="mx-auto mt-6  border-b-2"/>


        <header @click="showCfj=!showCfj" class="flex items-center rounded-md header-form mt-6">
            <div class="rounded-full border border-grey w-7 h-7">
                <!-- icon by feathericons.com -->
                <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="6 9 12 15 18 9">
                    </polyline>
                </svg>
            </div>
            <span class="text-grey-darkest font-medium text-xl ml-2">
                Cursos de Formación Judicial
            </span>
        </header>

        <div v-if="this.$page.props.aspirante" class="p-8 -mr-6 -mb-8 flex flex-wrap" v-show="showCfj">
            <table  class="w-full" style="margin: 0 10% 0 2% !important;" ref="tableCfj">
                <tr class=" font-bold">
                    <th class="px-6 pt-6 pb-4 text-left">Curso</th>
                    <th class="px-6 pt-6 pb-4 text-left">Descripción</th>
                    <th class="px-6 pt-6 pb-4 text-left">Adjunto</th>
                    <th class="px-6 pt-6 pb-4 text-center">Acciones</th>
                </tr>
                <tr  v-for="cursoCfj in this.$page.props.aspirante.cursosCfj" :key="cursoCfj.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                            {{ cursoCfj.curso }}
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                            {{  cursoCfj.descripcion }}
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left">
                        <a v-for="media in cursoCfj.media" :key="media.id" :href="media.original_url" :download="media.file_name" class="flex items-center group py-3">
                            <icon name="printer" class="w-5 h-5 mr-3" />
                            <button type="button" class="text-indigo-300">{{ media.file_name }}</button>
                        </a>
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-center">
                        <button type="button" class="mt-8 btn-login relative" v-on:click="cursos(aspirante.id,cursoCfj)">Editar</button>
                    </td>
                </tr>
                <button type="button" class="mt-8 btn-login relative" @click="cursos(aspirante.id)" >Agregar Curso</button>
            </table>
        </div>

        <div v-else v-show="showCfj" class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <h1>Usted debe terminar el registro para cargar un Curso de Formación Judicial.</h1>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center mt-1">
          <loading-button v-if="aspirante_id" :loading="form.processing" class="btn-login ml-auto" type="submit" :disabled="form.processing">Guardar Aspirante</loading-button>
          <button v-else  class="btn-login ml-auto" tabindex="-1" type="button" @click="create">Crear Aspirante</button>
        </div>

      <div class="mx-auto mt-6  border-b-2" />

      </form>
    </div>
</div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import Icon from '@/Shared/Icon'
import FormularioCfj from '../CursosCfj/Formulario.vue'
//import Date from '@/Shared/Date'
import AsignacionAspirante from '../AsignacionAspirante/Formulario';
import moment from 'moment';




export default {
    metaInfo() {
        return {
            // title: `${this.nombre} ${this.apellido}`,
        }
    },
    computed:{
        nombre:function () {
            // `this` apunta a la instancia vm
            if(this.form.nombre){
                return this.form.nombre
            }else{
                this.form.nombre = this.$page.props.auth.user.first_name
                return this.$page.props.auth.user.first_name
            }
        },
        apellido:function () {
            // `this` apunta a la instancia vm
            if(this.form.apellido){
                return this.form.apellido
            }else{
                this.form.apellido = this.$page.props.auth.user.last_name
                return this.$page.props.auth.user.last_name
            }
        },
        email:function () {
            // `this` apunta a la instancia vm
            if(this.form.correo_electronico){
                return this.form.correo_electronico
            }else{
                this.form.correo_electronico = this.$page.props.auth.user.email
                return this.$page.props.auth.user.email
            }
        },
        aspirante_id:function(){
            if(this.aspirante.id){
                return this.aspirante.id
            }else if(this.$page.props.aspirante){
                return this.$page.props.aspirante.id
            }
        },
        numero_inscripcion:function(){
            if(this.aspirante.numero_inscripcion != null){
                return this.aspirante.numero_inscripcion
            }else if(this.$page.props.aspirante != null){
                return this.$page.props.aspirante.numero_inscripcion
            }
        },
        fecha_inscripcion:function(){
            if(this.aspirante.fecha_inscripcion != null){
                return this.aspirante.fecha_inscripcion
            }else if(this.$page.props.aspirante != null){
                return this.$page.props.aspirante.fecha_inscripcion
            }
        },
        errorTelefono(){
            let s = (this.errors.codigo_area) ? this.errors.codigo_area : '';
            s = s + ( (this.errors.domicilioConstituido_telefono) ? ' ' + this.errors.domicilioConstituido_telefono : '');
            return s;
        },
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
        FileInput,
        Icon,
        AsignacionAspirante,
        FormularioCfj,
    },
    props: {
        aspirante: Object,
        lista_estudios:Object,
        certificado_adjunto:Object,
        curriculum_adjunto:Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                nombre: this.aspirante.nombre,
                apellido: this.aspirante.apellido,
                tipo_documento_id: this.aspirante.tipo_documento_id,
                numero_documento: this.aspirante.numero_documento,
                correo_electronico: this.aspirante.correo_electronico,
                fecha_de_nacimiento: this.aspirante.fecha_de_nacimiento,
                curriculum_adjunto:this.aspirante.curriculum_adjunto,
                cuit_cuil: this.$page.props.user_cuil ? this.$page.props.user_cuil : this.aspirante.cuit_cuil,
                certificado_adjunto: this.aspirante.certificado_adjunto,
                certificado_de_discapacidad: this.aspirante.certificado_de_discapacidad,
                tipodiscapacidad: this.aspirante.tipodiscapacidad,
                adaptaciones_o_necesidades_requeridas: this.aspirante.adaptaciones_o_necesidades_requeridas,

                domicilioConstituido_calle : this.aspirante.domicilioConstituido_calle,
                domicilioConstituido_numero : this.aspirante.domicilioConstituido_numero,
                domicilioConstituido_piso : this.aspirante.domicilioConstituido_piso,
                domicilioConstituido_departamento : this.aspirante.domicilioConstituido_departamento,
                domicilioConstituido_codigo_postal : this.aspirante.domicilioConstituido_codigo_postal,
                domicilioConstituido_localidad : this.aspirante.domicilioConstituido_localidad,
                domicilioConstituido_telefono : this.aspirante.domicilioConstituido_telefono,
                codigo_area_telefono:this.aspirante.codigo_area_telefono,

                experiencia_judicial : this.aspirante.experiencia_judicial ? this.aspirante.experiencia_judicial : 'NO',
                detalle_exp_judicial : this.aspirante.detalle_exp_judicial,
                auxiliar : this.aspirante.auxiliar ? this.aspirante.auxiliar : 'NO',
                auxiliar_de_servicio : this.aspirante.auxiliar_de_servicio ? this.aspirante.auxiliar_de_servicio : 'NO',

                estudio_id : this.aspirante.estudio_id,
                universitario_descripcion : this.aspirante.universitario_descripcion,
                tipoestudio : this.aspirante.tipoestudio,

                intereses : this.aspirante.intereses,
                estudio:this.aspirante.estudio,
                tipo_documento:this.aspirante.tipo_documento,

            }),
            options: [{
                value: 'true',
                label: 'SI'
            }, {
                value: 'false',
                label: 'NO'
            }],
            lista_documento: [{
                value: '1',
                label: 'DNI'
            },
            {
                value: '2',
                label: 'PASAPORTE'
            }],
            showDatos: true,
            showDomicilio:true,
            showExperiencia:true,
            showEstudios:true,
            showIntereses:true,
            showDesignaciones:true,
            showCfj:true,
            asignacion:false,
            dialogFormularioCfj:false,
            aspiranteId:0,
            curso:{},
            designacion:{},
            
        }
    },
    watch:{
        showCfj:function (newData, old) {
            if((newData == true)  && (this.$page.props.auth.user.owner == false)){
                let html = 
                '<p>Una vez enviado el Formulario y al cabo de una semana Ud. recibirá un email donde se le detallará cómo ingresar al CFJ (Centro de Formación Judicial) para poder realizar la capacitación obligatoria que completará su proceso de inscripción.</p>'

                +'<p>Al finalizar dicha capacitación podrá solicitar la certificación de que ha aprobado la misma al CFJ: cursos@jusbaires.gob.ar y deberá subirla a esta pestaña del formulario. </p>'

                const h = this.$createElement;
                const message = h("div", {domProps:{innerHTML: html}})

                this.$msgbox({
                    title: 'Aviso',
                    message:message,
                    confirmButtonText: 'OK',
                    center: true,
                });
            }
        }
    },
    mounted(){
        if (!this.aspirante_id){
            this.$message({
                showClose: true,
                duration: 6000,
                message: 'Los datos ingresados serán utilizados para contactarnos con usted, revíselos antes de enviarlos.',
            });
        }else if(this.$page.props.auth.user.owner == false){
            this.cartelCFJ();
        }
        
    },
    methods: {
        cartelCFJ(){
            let html = 
                '<p>Para hacer efectiva la inscripción debera realizar los Cursos de Formación Judicial segun resolución </p>'+
                '<a href="/archivos/Res_CM_N_0412021.pdf" download class="py-3">'+
                    '<button type="button" class="text-indigo-300">RES. CM Nº 41/2021</button>'+
                '</a>'

            const h = this.$createElement;
            const message = h("div", {domProps:{innerHTML: html}})

            this.$msgbox({
                title: 'Aviso',
                message:message,
                confirmButtonText: 'OK',
                center: true,
            });
        },
        update() {
            this.form.post(this.route('aspirantes.update', this.aspirante_id,{
                _method: 'put',
                forceFormData: true,
                certificado_adjunto: this.form.certificado_adjunto,
                curriculum_adjunto:this.form.curriculum_adjunto,

            }).url())
        },
        create() {
            this.form.post(this.route('aspirantes.store',{
                _method: 'post',
                forceFormData: true,
                certificado_adjunto: this.form.certificado_adjunto,
                curriculum_adjunto:this.form.curriculum_adjunto,
            }).url())
        },
        asigna(aspirante, designacion){
            this.aspiranteId = aspirante
            this.designacion = designacion
            this.asignacion = true;
        },
        closeAsignacionDialog(){
            this.asignacion = false;
            this.designacion = {};
        },
        cursos(aspirante, curso){
            this.aspiranteId = aspirante
            this.curso = curso
            this.dialogFormularioCfj = true;
        },
        closeCfjDialog(){
            this.dialogFormularioCfj = false;
            this.curso={};
        },
    },
    filters:{
        fecha(value){
            return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
        sino(designacion){
            if(designacion == true){
                return 'SI'
            }
            return 'NO'
        },
    }
}
</script>
<style scoped>
.sombra{
    z-index:2;
    position: absolute;
    top:0px;
    left:0px; 
    width:100%;
    height:100vh;
    background: rgba(0,0,0,0.6);
    display:flex;
    justify-content: center;
    align-items: center;
}
.ld-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background: #eee;
    opacity: 0.4;
}
.ld-container:before {
    content: "";
    height: 100%;
    display: inline-block;
    vertical-align: middle;
}

.ld-container .spinner-frame {
    display: inline-block;
    vertical-align: middle;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    border: 5px solid #fff;
    padding: 10px;
}

.ld-container .spinner-frame .spinner-cover {
    background: #fff;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: relative;
    z-index: 2;
}

.ld-container .spinner-frame .spinner-bar {
    background: #29d;
    width: 50%;
    height: 50%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100% 0 0 0;
    -webkit-animation: spinny 2s linear infinite;
    transform-origin: 100% 100%;
}
@-webkit-keyframes spinny {
    0% {
        transform: rotate(0deg);
        background: #29d;
    }
    50% {
        transform: rotate(180deg);
        background: #00427c;
    }
    100% {
        transform: rotate(360deg);
        background: #29d;
    }
}

</style>
